import axios from "axios";
import config from "@/configs/config";
import adminAuthHeader from "@/helpers/adminAuthHeader";

// Dedicated axios instance for the admin panel, pointed at compro_tef_be.
// Kept fully separate from helpers/service.js (system_tef_be) so the two
// token schemes never interfere with each other.
export default () => {
  const token = adminAuthHeader.get();
  return axios.create({
    baseURL: config.factoryTourApiUrl,
    headers: token ? { Authorization: "Bearer " + token } : {},
  });
};
